import React from 'react';

interface TicketShapeProps {
  children: React.ReactNode;
  className?: string;
  width?: number | string;
  height?: number | string;
  fillColor?: string;
}

const TicketShape: React.FC<TicketShapeProps> = ({ 
  children, 
  className = '', 
  width = 750, 
  height = 449,
  fillColor = '#c1c1c1'
}) => {
  // Handle responsive sizing
  const isResponsive = width === "100%" || height === "100%";
  const containerStyle = isResponsive 
    ? { width: '100%', height: '100%' }
    : { width: `${width}px`, height: `${height}px` };

  // Create a data URL for the ticket shape mask
  const ticketShapePath = "M663.98,307.41c-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15c.3,0,.59.03.88.07v-9.77c-.29.04-.58.07-.88.07-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15c.3,0,.59.03.88.07v-9.77c-.29.04-.58.07-.88.07-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15c.3,0,.59.03.88.07v-9.77c-.29.04-.58.07-.88.07-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15c.3,0,.59.03.88.07v-9.77c-.29.04-.58.07-.88.07-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15c.3,0,.59.03.88.07v-9.77c-.29.04-.58.07-.88.07-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15c.3,0,.59.03.88.07v-9.77c-.29.04-.58.07-.88.07-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15c.3,0,.59.03.88.07v-9.77c-.29.04-.58.07-.88.07-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15c.3,0,.59.03.88.07v-10.07c-.34.02-.68.04-1.03.04-8.45,0-15.3-6.81-15.38-15.23h-157.57c-.08,8.43-6.93,15.23-15.38,15.23s-15.3-6.81-15.38-15.23H100.66c-.08,8.43-6.93,15.23-15.38,15.23-.05,0-.1,0-.15,0v9.98c.1,0,.19-.01.29-.01,3.4,0,6.15,2.75,6.15,6.15s-2.75,6.15-6.15,6.15c-.1,0-.2-.01-.29-.01v9.66c.1,0,.19-.01.29-.01,3.4,0,6.15,2.75,6.15,6.15s-2.75,6.15-6.15,6.15c-.1,0-.2-.01-.29-.01v9.66c.1,0,.19-.01.29-.01,3.4,0,6.15,2.75,6.15,6.15s-2.75,6.15-6.15,6.15c-.1,0-.2-.01-.29-.01v9.66c.1,0,.19-.01.29-.01,3.4,0,6.15,2.75,6.15,6.15s-2.75,6.15-6.15,6.15c-.1,0-.2-.01-.29-.01v9.66c.1,0,.19-.01.29-.01,3.4,0,6.15,2.75,6.15,6.15s-2.75,6.15-6.15,6.15c-.1,0-.2-.01-.29-.01v9.66c.1,0,.19-.01.29-.01,3.4,0,6.15,2.75,6.15,6.15s-2.75,6.15-6.15,6.15c-.1,0-.2-.01-.29-.01v9.66c.1,0,.19-.01.29-.01,3.4,0,6.15,2.75,6.15,6.15s-2.75,6.15-6.15,6.15c-.1,0-.2-.01-.29-.01v9.66c.1,0,.19-.01.29-.01,3.4,0,6.15,2.75,6.15,6.15s-2.75,6.15-6.15,6.15c-.1,0-.2-.01-.29-.01v9.69s.1,0,.15,0c8.49,0,15.38,6.89,15.38,15.38,0,.05,0,.1,0,.15h359.48s0-.1,0-.15c0-8.49,6.89-15.38,15.38-15.38s15.38,6.89,15.38,15.38c0,.05,0,.1,0,.15h157.57s0-.1,0-.15c0-8.49,6.89-15.38,15.38-15.38.34,0,.69.02,1.03.04v-9.78c-.29.04-.58.07-.88.07ZM475.66,307.41c-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15,6.15,2.75,6.15,6.15-2.75,6.15-6.15,6.15ZM475.66,285.48c-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15,6.15,2.75,6.15,6.15-2.75,6.15-6.15,6.15ZM475.66,263.55c-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15,6.15,2.75,6.15,6.15-2.75,6.15-6.15,6.15ZM475.66,241.62c-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15,6.15,2.75,6.15,6.15-2.75,6.15-6.15,6.15ZM475.66,219.69c-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15,6.15,2.75,6.15,6.15-2.75,6.15-6.15,6.15ZM475.66,197.76c-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15,6.15,2.75,6.15,6.15-2.75,6.15-6.15,6.15ZM475.66,175.83c-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15,6.15,2.75,6.15,6.15-2.75,6.15-6.15,6.15ZM475.66,153.9c-3.4,0-6.15-2.75-6.15-6.15s2.75-6.15,6.15-6.15,6.15,2.75,6.15,6.15-2.75,6.15-6.15,6.15Z";

  const maskSvg = `data:image/svg+xml,${encodeURIComponent(`
    <svg viewBox="0 0 750 449" xmlns="http://www.w3.org/2000/svg">
      <path d="${ticketShapePath}" fill="black"/>
    </svg>
  `)}`;

  return (
    <div className={`relative ${className}`} style={containerStyle}>
      {/* SVG Background */}
      <svg
        className="absolute inset-0 w-full h-full"
        viewBox="0 0 750 449"
        preserveAspectRatio="xMidYMid meet"
        style={{ zIndex: 1 }}
      >
        <defs>
          <style>
            {`.ticket-shape { fill: ${fillColor}; }`}
          </style>
        </defs>
        <path 
          className="ticket-shape" 
          d={ticketShapePath}
        />
      </svg>
      
      {/* Content overlay with CSS mask */}
      <div 
        className="absolute inset-0 w-full h-full overflow-hidden" 
        style={{ 
          zIndex: 2,
          WebkitMask: `url("${maskSvg}")`,
          mask: `url("${maskSvg}")`,
          WebkitMaskSize: '100% 100%',
          maskSize: '100% 100%',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center'
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default TicketShape;